<script>
  import { createEventDispatcher, tick } from "svelte";
  import { Modal } from "svelte-utilities";

  const dispatch = createEventDispatcher();

  let modal;
  let customScale = 20;
  let input;

  $: parsedScale = parseFloat(customScale);
  $: isValid = Number.isFinite(parsedScale) && parsedScale > 0 && parsedScale <= 2000;

  function setScale() {
    if (!isValid) return;

    dispatch("setScale", { value: `1:${customScale}` });
  }

  export const open = async () => {
    modal.open();
    await tick();
    input.focus();
  };
</script>

<Modal
  bind:this={modal}
  closeable
  on:confirm={setScale}
  buttons={[
    { label: "Cancel", type: "cancel" },
    { label: "Set Custom Scale", type: "confirm", style: "primary", disabled: !isValid },
  ]}>
  <div slot="title">Set Custom Scale</div>
  <div slot="content" class="space-y-2 text-sm">
    <div class="flex items-center gap-2 justify-center">
      <input disabled value={1} />
      <div>:</div>
      <input bind:value={customScale} bind:this={input} />
    </div>
    <div class="text-red-500 text-center text-xs">
      {#if !isValid}
        Please enter a valid number between 0 and 2000
      {:else}
        &nbsp;
      {/if}
    </div>
  </div>
</Modal>

<style>
  input {
    @apply border p-1 rounded w-12;
  }
</style>
